import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "./api";
const AuthContext = createContext(null);
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const logout = () => {
      sessionStorage.removeItem(TOKEN_KEY);
      setUser(null);
    };
    window.addEventListener("forma-session-expired", logout);
    if (sessionStorage.getItem(TOKEN_KEY))
      api("/auth/me")
        .then((data) => setUser(data.user))
        .catch(logout)
        .finally(() => setLoading(false));
    else setLoading(false);
    return () => window.removeEventListener("forma-session-expired", logout);
  }, []);
  async function authenticate(mode, values) {
    const data = await api(`/auth/${mode}`, {
      method: "POST",
      body: JSON.stringify(values),
    });
    sessionStorage.setItem(TOKEN_KEY, data.token);
    setUser(data.user);
  }
  function logout() {
    sessionStorage.removeItem(TOKEN_KEY);
    setUser(null);
  }
  return (
    <AuthContext.Provider value={{ user, loading, authenticate, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
export const useAuth = () => useContext(AuthContext);
